import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import styled from "styled-components";
import { standardInputStyles, standardLabelStyles } from "../general.styled";

export const MultiSelectContainer = styled.div<{ maxWidth?: number }>`
  position: relative;
  width: 100%;
  max-width: ${(props) => (props.maxWidth ? props.maxWidth + "px" : "250px")};
  margin-bottom: 16px;
`;

export const MultiSelectLabel = styled.label<{
  required?: boolean;
  hasValue?: boolean;
  isFocused?: boolean;
  disabled?: boolean;
}>`
  ${standardLabelStyles}
`;

export const MultiSelectInput = styled.div<{
  fontSize?: FontSize;
  hasError?: boolean;
  hasValue?: boolean;
  isOpen?: boolean;
  disabled?: boolean;
}>`
  ${standardInputStyles}
`;

export const MultiSelectArrow = styled.div<{ isOpen?: boolean }>`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%)
    rotate(${(props) => (props.isOpen ? "180deg" : "0deg")});
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #6b7280;
  transition: transform 0.2s ease;
  pointer-events: none;
`;

export const SelectedContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-width: calc(100% - 30px);
  overflow: hidden;
`;

export const SelectedTag = styled.span`
  background: ${Color.DarkGrey};
  color: ${Color.White};
  padding: 2px 8px;
  border-radius: 12px;
  font-size: ${FontSize.Small};
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-weight: 400;
  white-space: nowrap;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const MoreIndicator = styled.span`
  color: #6b7280;
  font-size: ${FontSize.Small};
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-weight: 400;
`;

export const MultiSelectList = styled.ul<{ isOpen?: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: ${Color.White};
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  margin: 4px 0 0 0;
  padding: 4px 0 12px 0;
  list-style: none;
  display: ${(props) => (props.isOpen ? "block" : "none")};
`;

export const MultiSelectItem = styled.li`
  padding: 8px 12px;
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-size: ${FontSize.Small};
  color: ${Color.InputTextColor};
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background-color: #f8f9fa;
  }
`;

export const Checkbox = styled.div<{ checked?: boolean }>`
  width: 16px;
  height: 16px;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  background: ${(props) => (props.checked ? "#3b82f6" : Color.White)};
  position: relative;
  flex-shrink: 0;
  transition: all 0.2s ease;

  ${(props) =>
    props.checked &&
    `
    &::after {
      content: '✓';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: ${Color.White};
      font-size: ${FontSize.Tiny};
      font-weight: bold;
    }
  `}
`;

export const OptionLabel = styled.span`
  flex: 1;
  user-select: none;
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-size: ${FontSize.Small};
  color: ${Color.InputTextColor};
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 4px;
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  color: #3b82f6;
  font-size: ${FontSize.Small};
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-weight: 500;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 3px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f0f7ff;
  }
`;
